import { FunctionalComponent, h } from "@stencil/core";
import { tableClass } from "../constants";

interface TableHeaderProps {
    group?: boolean;
    sortable?: boolean;
    label?: string;
    sortField?: string;
}

export const TableDataHeader: FunctionalComponent<TableHeaderProps> = (
    { group = false, sortable = false, label = "", sortField = "" },
    children
) => (
    <th
        class={{
            [`${tableClass}__th`]: true,
            [`${tableClass}__th--group`]: group
        }}
        scope="col"
    >
        {sortable && label !== "" && (
            // @ts-expect-error Check for typing
            <ux-table-data-sort sortField={sortField !== "" ? sortField : null}>{label}</ux-table-data-sort>
        )}
        {!sortable && label !== "" && label}
        {children}
    </th>
);
